import React from 'react'

import BulkImport from '../bulk-import'
import { withRouter } from 'react-router'

const ReservationImport = ({ params }) => {
  if (!params.sessionSaleId) {
    return <p>Missing sessionSaleId param</p>
  }
  return (
    <BulkImport
      title='Import Session Sale Reservations'
      uploadPath={`admin/session_sales/${params.sessionSaleId}/upload-reservations`}
      templatePath='admin/session_sales/reservation-upload-template'
    >
      Import reservations into this Session Sale. This import process will:
      <ul>
        <li>Create reservations for users in the upload.</li>
        <li>If an institution ID is provided, it will create the reservation as an institution reservation for the given user.</li>
        <li>If created date is provided, it will set that date as the reservation created date.  Otherwise, the current date will be used.</li>
        <ul>
          <li>Expects ISO-8601 date format e.g. <code>2022-08-09T12:50:00-04:00</code></li>
        </ul>
        <li>If unregistered has the value <code>YES</code> then the user will be unregistered from the session sale and other values will be ignored.</li>
      </ul>
    </BulkImport>
  )
}

export default withRouter(ReservationImport)
